import { render } from "./PeoplePickerMs.vue?vue&type=template&id=387f7447&scoped=true"
import script from "./PeoplePickerMs.vue?vue&type=script&lang=js"
export * from "./PeoplePickerMs.vue?vue&type=script&lang=js"

import "./PeoplePickerMs.vue?vue&type=style&index=0&id=387f7447&scoped=true&lang=css"
import "./PeoplePickerMs.vue?vue&type=style&index=1&id=387f7447&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387f7447"]])

export default __exports__